import { notifications } from '~/app/notifications'
import AppButton from '@theme/components/atom/AppButton'
import LoadingMixin from '~/mixins/LoadingMixin'
import RemoveButton from '@theme/components/atom/RemoveButton'

export default {
  mixins: [LoadingMixin],
  components: {
    AppButton,
    RemoveButton,
  },
  data() {
    return {
      creditsInputVisible: false,
      creditsToApply: null,
    }
  },
  methods: {
    toggleCreditsInput() {
      this.creditsInputVisible = !this.creditsInputVisible
    },
    async submitCredits() {
      if (this.creditsToApply <= 0) {
        notifications.danger(this.$t('CheckoutApplyCredits.notifications.error.emptyCredits'))
        return
      } else if (this.creditsToApply > this.$store.state.user.userCredits) {
        notifications.danger(this.$t('CheckoutApplyCredits.notifications.error.notEnoughCredits'))
        return
      } else if (this.$store.state.cart.cartData.prices.totalWithTax === 0) return

      this.startLoading()
      const response = await this.$store.dispatch('cart/SET_CREDITS', this.creditsToApply)
      this.creditsToApply = null
      notifications.success(this.$t('CheckoutApplyCredits.notifications.success'))
      this.stopLoading()
    },
    async removeCredits() {
      this.$refs.removeCredits.startLoading()
      this.$store.dispatch('cart/SET_CREDITS', 0)
    },
  },
}
